import { getHostName } from "lib/amplify/amplify";

export const env: "development" | "production" | "test" =
  (process.env.REACT_APP_API as "production" | undefined) ||
  process.env.NODE_ENV ||
  "development";

type ConfigItem = {
  SERVICES_URL: string;
  sentry: {
    dsn: string;
    environment: typeof env;
  };
};

type Config = {
  [key in typeof env]: ConfigItem;
};

const getServicesUrl = () => {
  const hostName = getHostName();
  return hostName === "app.realforce.com"
    ? "https://api.realforce.com"
    : "https://api-prod.adfenix.com";
};

const config: Config = {
  development: {
    SERVICES_URL: "http://localhost:3001",
    sentry: {
      dsn: "https://6b2c4430829045fa84254227b5f727f1@sentry.io/1461858",
      environment: "development"
    }
  },

  production: {
    SERVICES_URL: getServicesUrl(),
    sentry: {
      dsn: "https://6b2c4430829045fa84254227b5f727f1@sentry.io/1461858",
      environment: "production"
    }
  },
  test: {
    SERVICES_URL: "http://localhost:3001",
    sentry: {
      dsn: "https://6b2c4430829045fa84254227b5f727f1@sentry.io/1461858",
      environment: "test"
    }
  }
};

const selectedConfig = config[env];

export default selectedConfig;
